export default __webpack_public_path__ + "static/media/worstVerbatim.335e6ac9.png";